import React,{ Component } from "react"
import { Button, Carousel, Container, Row } from "react-bootstrap"

const CarouselSv: React.FC = () => {
        return (
            // Import react bootstrap carousel implementation here with sv images and text on each image
            // carousel images height 580px and width 100%

            // over write the below carousel css in index.css file with carousel images should be background images and text should be over the left side of the carousel image and carousel image should cover transparent white as the text should be visible clearly based on primary color
             
            <Carousel className="carouselMain">
                <Carousel.Item>
                    <img className="d-block w-100 carousel-image" src="/images/Kalpvriksha.jpg" alt="Second slide" />
                    <Carousel.Caption>
                        <h1>Second Slide Label</h1>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum. Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        <Button variant="primary">View More</Button>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className="d-block w-100 carousel-image" src="/images/mrp.jpg" alt="Second slide" />
                    <Carousel.Caption>
                        <h1>Second Slide Label Title is</h1>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum. Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        <Button variant="primary">View More</Button>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img className="d-block w-100 carousel-image" src="/images/vue.jpg" alt="First slide" />
                    <Carousel.Caption>
                        <h1>First Slide Label</h1>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum. Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        <Button variant="primary">View More</Button>
                    </Carousel.Caption>
                </Carousel.Item>
                
                <Carousel.Item>
                    <img className="d-block w-100 carousel-image" src="/images/krl.jpg" alt="Third slide" />
                    <Carousel.Caption>
                        <h1>Third Slide Label</h1>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum. Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                        <Button variant="primary">View More</Button>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        )
}

export default CarouselSv;